module.exports = __webpack_public_path__ + "static/blueskies-28ef7f0bbfe2f5184b5bf0d08907941c.jpeg";